import React from 'react';
import './content.css';
import cartContext from '../Context/cartContext';
import wishlistContent from '../wishlistContent/wishlistContent';
import { useContext,useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Content({ data }) {
    const { cart, setCart } = useContext(cartContext);
    const { wishlist, setWishlist } = useContext(wishlistContent);
    const [item,setItem1] = useState([]);
    const [wish,setWish] = useState([]);

    return (
        <div className='content1'>

            {data.map((it, idx) => {
                return (
                    <div class="card" key={idx}>
                        <img src={it.image} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">{it.brand}</h5>
                            <p class="card-text">{it.type}</p>
                            <p class="card-text"><span className='currentPrice'>{<i class="fa-solid fa-indian-rupee-sign"></i>}{it.price}</span>
                                <span className='OriginalPrice'>{<i class="fa-solid fa-indian-rupee-sign"></i>}{it.MP}</span> ({it.offer}% off)</p>
                             <button type='button' className='btn btn-outline-dark bagButton' onClick={() => {
                                    toast.success("You have succesfully added item to cart", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                        });
                                let a = JSON.parse(localStorage.getItem('userCart'));
                                if(a){
                                a.push({ image: it.image, id: uuidv4(), brand: it.brand, type: it.type, currentPrice: it.price, OriginalPrice: it.MP, offer: it.offer });
                                localStorage.setItem('userCart', JSON.stringify(a));
                                }else{
                                    let b = [{ image: it.image, id: uuidv4(), brand: it.brand, type: it.type, currentPrice: it.price, OriginalPrice: it.MP, offer: it.offer }]
                                localStorage.setItem('userCart', JSON.stringify(b));
                                }
                              }}>
                                <i class="fa-solid fa-bag-shopping"></i> Add To Bag</button>
                            <button type='button' className='btn btn-outline-dark wishlistBUTTON' onClick={() => {
                                toast.success("You have succesfully added item to wishlist", {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                    });
                                let a = JSON.parse(localStorage.getItem('userWishlist'));
                                if(a){
                                a.push({ image: it.image, id: uuidv4(), brand: it.brand, type: it.type, currentPrice: it.price, OriginalPrice: it.MP, offer: it.offer });
                                localStorage.setItem('userWishlist', JSON.stringify(a));
                                }else{
                                    let b = [{ image: it.image, id: uuidv4(), brand: it.brand, type: it.type, currentPrice: it.price, OriginalPrice: it.MP, offer: it.offer }]
                                localStorage.setItem('userWishlist', JSON.stringify(b));
                                }
                               }}><i class="fa-regular fa-heart"></i> Add To WishList</button>
                           
                        </div>
                     
                    </div>
                )
            })}
             <ToastContainer />
        </div>
    )
}